import React from 'react';
import { Select } from 'baseui/select';

export function CustomSelect({ options, value, onChange, placeholder }) {
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      clearable={false}
      searchable={false}
      overrides={{
        Root: {
          style: {
            zIndex: 1
          }
        }
      }}
    />
  );
}
